import React, { PropsWithChildren } from 'react';
import { useProfile } from 'src/features/auth/auth.hooks';
import { User } from 'src/features/users/users.types';

interface RoleProps {
  roles: string[];
}

const ComponentRoleProtected = (props: PropsWithChildren<RoleProps>) => {
  const user = useProfile() as User;
  const { roles, children } = props;

  if (roles && roles.includes(user.role)) {
    return <>{children}</>;
  }
  return <></>;
};

export default ComponentRoleProtected;
